import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  showPrinterAlert: false,
  currentAlert: null,
  alerts: [],
};

const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    addAlert: (state, action) => {
      const newAlert = action.payload;

      const existingAlert = state.alerts.find(
        (alert) =>
          alert.order_id === newAlert.order_id && alert.type === newAlert.type
      );

      const shouldAddAlert = !existingAlert;

      if (shouldAddAlert) {
        state.alerts.push(newAlert);

        const hasNoCurrentAlert = !state.currentAlert;

        if (hasNoCurrentAlert) {
          state.currentAlert = newAlert;
        }
      }
    },
    removeAlert: (state, action) => {
      state.alerts = state.alerts.filter(
        (alert) => alert.id !== action.payload
      );

      const isRemovingCurrentAlert = state.currentAlert?.id === action.payload;

      if (isRemovingCurrentAlert) {
        state.currentAlert = state.alerts[0] || null;
      }
    },
    setCurrentAlert: (state, action) => {
      state.currentAlert = action.payload;
    },
    clearCurrentAlert: (state) => {
      state.currentAlert = null;
    },
    setShowPrinterAlert: (state, action) => {
      console.log(
        "Redux Action: setShowPrinterAlert called with value:",
        action.payload
      );
      state.showPrinterAlert = action.payload;
      console.log(
        "Redux State: showPrinterAlert is now:",
        state.showPrinterAlert
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const {
  addAlert,
  removeAlert,
  setCurrentAlert,
  clearCurrentAlert,
  setShowPrinterAlert,
} = alertsSlice.actions;

export default alertsSlice.reducer;
